import { TABLE_IDS } from '@cards/engine';
import { cardRef, defineGameCard, onResolve } from '../authoring/index.js';
import { createFragmentAtCell, createFragmentInLocation, plannedCell } from './helpers.js';
import { ScrapCard } from './tokens.js';
export const ScatterBoltsCard = defineGameCard({
    id: 'scatter_bolts',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: {
            target: 'cell',
            validatePlan(state, playerId, plan) {
                const cell = plan.targetCellId === undefined ? undefined : state.board.cells[plan.targetCellId];
                return cell !== undefined && cell.side === state.players[playerId]?.side && cell.occupantId === null;
            },
        },
    },
    presentation: {
        name: 'Россыпь болтов',
        description: 'Создаёт Фрагмент в выбранной ячейке и ещё один в случайной другой локации. Если хотя бы один вызвал Сборку, создаёт Хлам в третьей локации.',
        glyph: {
            colors: ['#10213A', '#3A3236', '#494F57', '#662E1E', '#A96128'],
            rows: [
                '....................',
                '.......111..........',
                '......12231.........',
                '.....133321..1111...',
                '.....132321.145521..',
                '......1111.1555441..',
                '....111311155541151.',
                '...13313215544444441',
                '.111221321444112421.',
                '132212132141145111..',
                '1211121321133144411.',
                '.1.1111321222131441.',
                '..15551311211333141.',
                '.15555211331322111..',
                '1555521321321211121.',
                '155541133113322221..',
                '122221.13132123221..',
                '.1111...1221.1111...',
                '.........11.........',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('fragment'), cardRef('reconstructed_robot'), cardRef('scrap')],
    abilities: [
        onResolve((ctx) => {
            const ownerId = ctx.self.controllerId;
            const targetCellId = plannedCell(ctx);
            if (targetCellId === undefined)
                return;
            const selectedTable = ctx.q.cell(targetCellId)?.tableId;
            if (selectedTable === undefined)
                return;
            const randomTable = ctx.rng.shuffle(TABLE_IDS.filter((tableId) => tableId !== selectedTable))[0];
            if (randomTable === undefined)
                return;
            const selectedResult = createFragmentAtCell(ctx, ownerId, targetCellId);
            const randomResult = createFragmentInLocation(ctx, ownerId, randomTable);
            const assembled = selectedResult.assembled || randomResult.assembled;
            if (assembled) {
                const third = TABLE_IDS.find((tableId) => tableId !== selectedTable && tableId !== randomTable);
                if (third !== undefined)
                    ctx.ops.createTokenInLocation(ScrapCard.id, ownerId, third);
            }
        }),
    ],
    ui: { mechanics: ['fragment', 'assembly', 'scrap'] },
});
//# sourceMappingURL=scatter-bolts.js.map